import { render, staticRenderFns } from "./ModalEliminarDocumento.vue?vue&type=template&id=1cfaf69f&scoped=true&"
import script from "./ModalEliminarDocumento.vue?vue&type=script&lang=js&"
export * from "./ModalEliminarDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfaf69f",
  null
  
)

export default component.exports